import FilterOperator from "@mapmycustomers/shared/enum/FilterOperator";
import FilterModel from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";

import { isSimpleCondition } from "@app/util/viewModel/assert";

import { OPERATORS_ALLOWING_EMPTY_VALUE } from "./consts";

// returns true if there is at least one condition with no value, which probably indicates
// that user just added a new field and it has no value yet (or changed field or changed operator)
const hasIncompleteValue = (filterModel: Partial<FilterModel>): boolean => {
  // iterate over all filters and find those which have no value
  // except when operator is one of OPERATORS_ALLOWING_EMPTY_VALUE since these operators naturally support no value
  return Object.keys(filterModel)
    .filter((fieldFilterName) => fieldFilterName !== "viewAs") // skip fake viewAs field
    .some((fieldFilterName) => {
      if (
        filterModel[fieldFilterName] &&
        isSimpleCondition(filterModel[fieldFilterName]!) &&
        !OPERATORS_ALLOWING_EMPTY_VALUE.includes(
          filterModel[fieldFilterName]!.operator as FilterOperator
        )
      ) {
        // we already checked that filterModel[fieldFilterName] is defined and is SimpleCondition
        // @ts-ignore
        if (filterModel[fieldFilterName]!.value === undefined) {
          return true;
        }
      }
      return false;
    });
};

export default hasIncompleteValue;
